import { Menu, MenuItem } from "@material-ui/core";
import React from "react";
import { Button } from "react-bootstrap";
import { Editor } from "react-draft-wysiwyg";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import { EditorState, Modifier } from "draft-js";
import styled from "styled-components";
import ApiClient from "utils/ApiClient";

const NewEditor = ({ editorState, setEditorState, variables, disabled, showAlert }) => {
  const onEditorStateChange = (editorState) => {
    if (disabled) {
      showAlert("Cannot edit body while draft is selected", false);
      return;
    }
    setEditorState(editorState);
    // setTimeout(() => {
    //   try {
    //     let el = document.querySelector(".rdw-fontfamily-placeholder");
    //     el.style.fontFamily = `${el.innerHTML}`;
    //   } catch (error) {
    //     console.log(error);
    //   }
    // }, 100);
    // const ar = document.querySelectorAll(".DraftEditor-root span");
    // Array.from(ar).forEach((el) => {
    //   if (el.style.fontFamily.length > 0) {
    //     let font = el.style.fontFamily;
    //     el.style.setProperty("font-family", font, "important");
    //   }
    // });
  };

  const fileUpload = async (file) => {
    const form = new FormData();
    form.append("Filedata[]", file, file.name);
    try {
      const resp = await ApiClient.File.tempUpload(form);
      const link = resp.files[0].path;
      return new Promise((resolve, reject) => {
        resolve({ data: { link: link } });
      });
    } catch (error) {
      window.appStore.notificationStore.showNotification(
        "Something went wrong while uploading file. Please try again later.",
        "error"
      );
    }
  };

  return (
    <div className="demo-root" style={{ maxWidth: "80vw" }}>
      <Editor
        toolbarClassName="rdw-storybook-toolbar"
        wrapperClassName="rdw-storybook-wrapper"
        editorClassName="rdw-storybook-editor"
        editorState={editorState}
        onEditorStateChange={onEditorStateChange}
        toolbarCustomButtons={[
          <CustomInsertVariable variables={variables} onEditorStateChange={onEditorStateChange} />,
        ]}
        toolbar={{
          options: [
            "inline",
            "fontSize",
            // "fontFamily",
            "list",
            "textAlign",
            "link",
            "emoji",
            "image",
            "remove",
            "history",
          ],
          image: { uploadCallback: fileUpload, previewImage: true },
          inline: {
            options: ["bold", "italic", "underline", "strikethrough"],
          },
          textAlign: {
            options: ["left", "center"],
          },
          // fontFamily: {
          //   options: ["Arial", "Georgia", "Impact", "Tahoma", "Times New Roman", "Verdana"],
          //   className: "new-editor-font-family",
          //   component: undefined,
          //   dropdownClassName: "new-editor-font-family-dropdown",
          // },
        }}
      />
    </div>
  );
};
export default NewEditor;

export const CustomInsertVariable = (props) => {
  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  const closeMenu = () => {
    setTimeout(() => handleClose(), 1);
  };

  const onClickHandler = (data) => {
    const { editorState, onChange } = props;
    var contentState = Modifier.replaceText(
      editorState.getCurrentContent(),
      editorState.getSelection(),
      `<%=${data}%>`,
      editorState.getCurrentInlineStyle()
    );
    onChange(EditorState.push(editorState, contentState, "insert-characters"));
    closeMenu();
  };
  return (
    <div className="rdw-custom-btn">
      <StyledButton
        id="demo-positioned-button"
        aria-controls="demo-positioned-menu"
        aria-haspopup="true"
        aria-expanded={open ? "true" : undefined}
        onClick={handleClick}
        variant="contained"
      >
        Insert Variable
      </StyledButton>
      <Menu
        id="demo-positioned-menu"
        aria-labelledby="demo-positioned-button"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        anchorOrigin={{
          vertical: "top",
          horizontal: "left",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "left",
        }}
      >
        {props.variables.map((el) => (
          <MenuItem
            key={el.alias_path}
            id={el.alias_path}
            onClick={() => {
              onClickHandler(el.alias_path);
            }}
          >
            {el.alias_path}
          </MenuItem>
        ))}
      </Menu>
    </div>
  );
};

const StyledButton = styled(Button)`
  && {
    border: 1px solid gray;
    padding: 5px;
    marginbottom: 5px;
  }
`;
